var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0039 12.1V19.8C22.0039 21.015 21.0189 22 19.8039 22H2.20391C0.98888 22 0.00390625 21.015 0.00390625 19.8V2.2C0.00390625 0.984973 0.98888 0 2.20391 0H9.90391V2.2H2.20391V19.8H19.8039V12.1H22.0039ZM16.9849 0C17.7051 0 18.3955 0.287562 18.8997 0.795765L21.2107 3.10675C21.7186 3.6146 22.0039 4.30339 22.0039 5.02159C22.0039 5.73979 21.7186 6.42858 21.2107 6.93642L12.0571 16.0861C11.2887 16.9724 10.1996 17.517 8.95187 17.6026H4.40381V16.5026L4.40738 12.966C4.50109 11.8061 5.04034 10.7276 5.86295 10.0028L15.0687 0.797091C15.5758 0.286913 16.2655 0 16.9849 0ZM10.4482 14.5878C10.0089 15.0902 9.46193 15.3637 8.87429 15.4053L6.60391 15.4032V13.0546C6.64825 12.5502 6.92395 11.9987 7.36962 11.6045L16.6288 2.34834C16.723 2.2534 16.8512 2.2 16.985 2.2C17.1187 2.2 17.2469 2.2534 17.3411 2.34834L19.6552 4.66239C19.7504 4.75766 19.804 4.88686 19.804 5.02159C19.804 5.15631 19.7504 5.28552 19.6552 5.38078L10.4482 14.5878Z",
    fill: "#a1c9b1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudy);
export default __webpack_public_path__ + "static/media/study.0b1600e3cc271e85658d36f3140da5da.svg";
export { ForwardRef as ReactComponent };